export const SAVE_APPOINTMENT = "SAVE_APPOINTMENT"
export const SAVE_APPOINTMENT_FAIL = "SAVE_APPOINTMENT_FAIL"
export const SAVE_APPOINTMENT_SUCCESS = "SAVE_APPOINTMENT_SUCCESS"
export const SAVE_APPOINTMENT_RESET = "SAVE_APPOINTMENT_RESET"

export const saveAppointment = (params) => {
    return { type: SAVE_APPOINTMENT, params }
}
export const saveAppointmentFail = (response) => {
    return { type: SAVE_APPOINTMENT_FAIL, response }
}
export const saveAppointmentSuccess = (response) => {
    return { type: SAVE_APPOINTMENT_SUCCESS, response }
}
export const saveAppointmentReset = () => {
    return { type: SAVE_APPOINTMENT_RESET }
}